import * as MarketingUser from '@/services/rest-api/lib/customer/marketing-user'
import { GET_USER_GROUP } from '@/services/api/setting/user/userGroup'
import store from '@/state/store'
import { Helper } from '@/mixin/helper'
import { TMS_MARKETING_USER_FILTER } from '@/helpers/tms-access'

export default {
  computed: {
    hasTmsUserGroupAccess() {
      const hasAccessAll = store.getters['identity/hasAccessAll']

      return (
        hasAccessAll(['tms-user-group:read']) &&
        Helper.methods.isSuperUser()
      )
    },
    acceptModalFields() {
      const translate = (key, fallback) => {
        const translated = this.$t(key)

        return translated === key ? fallback : translated
      }

      const fields = [
        {
          name: 'user_group_id',
          isShow: this.hasTmsUserGroupAccess,
          label: translate('delivery.fields.userGroup', 'Grup Pengguna'),
          type: 'value-help-v2',
          placeholder: `${translate('global.form.select', 'Pilih')} ${translate('delivery.fields.userGroup', 'Grup Pengguna')}`,
          trackBy: 'id',
          displayedBy: 'name',
          help: true,
          validation: 'required',
          listGetter: async (opts) => {
            let result = {}
            const filter = {
              pagination: {
                page: opts?.page,
                show: opts?.limit,
              },
              search: opts?.search,
            }

            const res = await this.$apollo.query({
              query: GET_USER_GROUP,
              fetchPolicy: 'no-cache',
              variables: {
                filter: {
                  ...filter,
                },
              },
            })

            const ugroups = res.data.ugroups.ugroups

            result = {
              metadata: {
                total_count: ugroups.pagination.total,
                page: ugroups.pagination.page,
              },
              data: {
                paginated_result: ugroups.data,
              },
            }

            return result
          },
          tableFields: [
            {
              label: translate('delivery.fields.userGroup', 'Grup Pengguna'),
              key: 'name',
              isSortable: false,
            },
            {
              label: translate('delivery.fields.vehicleGroup', 'Grup Kendaraan'),
              key: 'vgroups',
              isSortable: false,
              formatter: (value) => {
                return value?.length != null
                  ? (value.length === 0 ? translate('delivery.fields.allVehicleGroup', 'Semua Grup Kendaraan') : value.length)
                  : '-'
              },
            },
          ],
          isMandatory: true,
        },
        {
          name: 'marketing_user_id',
          isShow: true,
          optionsGetter: (opts) => {
            let filters = [TMS_MARKETING_USER_FILTER]
            if (this.hasTmsUserGroupAccess) {
              filters = [TMS_MARKETING_USER_FILTER]
              if (this.formValues?.user_group_id != null) {
                filters.push(`ugroup.id eq ${this.formValues.user_group_id}`)
              }
            }
            return MarketingUser.get(filters)(opts)
          },
          optionLabelFn: ({ item }) => item.name,
          type: 'select-resourceful-v2',
          label: translate('delivery.fields.marketingEmployee', 'Karyawan Pemasaran'),
          placeholder: `${translate('global.form.select', 'Pilih')} ${translate('delivery.fields.marketingEmployee', 'Karyawan Pemasaran')}`,
          trackBy: 'id',
          disabled: this.hasTmsUserGroupAccess && this.formValues?.user_group_id == null,
        },
        {
          name: 'customer_name',
          isShow: !this.isBilledCustomerExists,
          type: 'text',
          validation: 'required',
          label: translate('delivery.fields.customerName', 'Nama Pelanggan'),
          placeholder: translate('delivery.fields.customerName', 'Nama Pelanggan'),
        },
      ]

      return fields.filter((field) => field.isShow !== false)
    },
  },
}
